const Icon = ({ className }: { className?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" className={`icon icon-sun ${className}`}>
    <path
      className="sun main-outline"
      xmlns="http://www.w3.org/2000/svg"
      d="M24 36a12 12 0 1 1 0-24 12 12 0 0 1 0 24M22 2h4v6h-4zm0 38h4v6h-4zM7.03 9.858 9.858 7.03l4.242 4.242-2.828 2.828zm26.87 26.87 2.828-2.828 4.242 4.242-2.828 2.828zm4.242-29.7 2.828 2.83-4.242 4.242-2.828-2.828 4.242-4.242zM11.272 33.9l2.828 2.828-4.242 4.242-2.828-2.828zM46 22v4h-6v-4zM8 22v4H2v-4z"
    ></path>
  </svg>
);

export default Icon;
